// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1___6d3b9dcd80b92156a87","cls2":"AuthorHeader-cls2___700465bf06a6964129c AuthorHeader-cls1___6d3b9dcd80b92156a87"};